// import Cookies from "js-cookie";

// function tierIndex(mbps, saveData) {
//   if (saveData) return 3;
//   if (mbps >= 3) return 0;
//   if (mbps > 2) return 1;
//   if (mbps > 1) return 2;
//   return 3;
// }

// export async function probeMbps({
//   probeUrl = "https://mvpblobcdn.blob.core.windows.net/blobimages/256k.bin",
//   warmupBytes = 128_000,
//   measureBytes = 1_000_000,
//   signal,
// } = {}) {
//   const url = `${probeUrl}?t=${Date.now()}&r=${Math.random().toString(36).slice(2)}`;
//   const start = performance.now();
//   const resp = await fetch(url, { cache: "no-store", signal });

//   const reader = resp.body?.getReader();
//   let total = 0,
//     measured = 0,
//     measureStart;

//   if (!reader) {
//     // Fallback: whole body
//     const buf = await resp.arrayBuffer();
//     total = buf.byteLength;
//     const secs = Math.max((performance.now() - start) / 1000, 0.001);
//     const mbps = (total * 8) / 1e6 / secs;
//     console.log("[probe] fallback", { totalBytes: total, secs, mbps });
//     return mbps;
//   }

//   while (true) {
//     const { done, value } = await reader.read();
//     if (done) break;
//     total += value.length;

//     if (measureStart == null && total >= warmupBytes) {
//       measureStart = performance.now();
//     }
//     if (measureStart != null) {
//       measured += value.length;
//       if (measured >= measureBytes) {
//         try {
//           reader.cancel();
//         } catch {}
//         break;
//       }
//     }
//   }

//   const end = performance.now();
//   const secs = Math.max((measureStart ?? start, end) && (end - (measureStart ?? start)) / 1000, 0.001);
//   const usedBytes = measureStart ? measured : total; // if file was smaller than warmup
//   const mbps = (usedBytes * 8) / 1e6 / secs;
//   const saveData = navigator.connection.saveData;

//   const result = {
//     totalBytes: total,
//     measuredBytes: usedBytes,
//     warmupSkipped: !!measureStart,
//     secs,
//     mbps,
//     saveData,
//     idxOffset: tierIndex(mbps, saveData),
//   };

//   console.log(result);
//   Cookies.set("networkQuality", JSON.stringify(result));
// }

import Cookies from "js-cookie";

// ---- small helpers ----
const COOKIE_NAME = "networkQuality";
const COOKIE_OPTS = { path: "/", secure: true, sameSite: "Lax", expires: 7 }; // explicit
// const DEFAULT_NQ = { idxOffset: 0, mbps: 0 }; // safe default

function tierIndex(mbps, saveData) {
  if (saveData) return 1;
  if (mbps >= 0.5) return 0;
  if (mbps > 0.15) return 1;
  if (mbps > 0.05) return 2;
  return 3;
}

// ---- the probe (with timeout + robust fallbacks) ----
export async function probeMbps({
  probeUrl = "https://mvpblobcdn.blob.core.windows.net/blobimages/750kb.bin",
  warmupBytes = 64_000,
  measureBytes = 384_000,
  timeoutMs = 30000,
} = {}) {
  const url = `${probeUrl}?t=${Date.now()}&r=${Math.random().toString(36).slice(2)}`;

  // Abort after timeout so we don’t hang forever
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort("timeout"), timeoutMs);

  let mbps = 0,
    usedBytes = 0,
    total = 0,
    warmupStarted = false,
    secs = 0;

  try {
    const start = performance.now();
    const resp = await fetch(url, { cache: "no-store", signal: controller.signal });

    // If stream reading is supported, measure a chunk of data
    const reader = resp.body?.getReader();
    if (reader) {
      let measured = 0,
        measureStart;
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        total += value.length;

        if (measureStart == null && total >= warmupBytes) measureStart = performance.now();
        if (measureStart != null) {
          warmupStarted = true;
          measured += value.length;
          if (measured >= measureBytes) {
            try {
              reader.cancel();
            } catch {}
            break;
          }
        }
      }
      const end = performance.now();
      secs = Math.max((measureStart ?? start, end) && (end - (measureStart ?? start)) / 1000, 0.001);
      usedBytes = warmupStarted ? measured : total;
      mbps = (usedBytes * 8) / 1e6 / secs;
    } else {
      // Fallback: read all
      const buf = await resp.arrayBuffer();
      total = buf.byteLength;
      secs = Math.max((performance.now() - start) / 1000, 0.001);
      usedBytes = total;
      mbps = (total * 8) / 1e6 / secs;
    }
  } catch (err) {
    // If it times out or fails, keep a safe default and mark mbps=0
    console.warn("[probe] failed", err);
    mbps = 0;
    usedBytes = 0;
    secs = 0.001;
  } finally {
    clearTimeout(t);
  }

  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const result = {
    totalBytes: total,
    measuredBytes: usedBytes,
    warmupSkipped: warmupStarted,
    secs,
    mbps,
    saveData,
    idxOffset: tierIndex(mbps, saveData),
    ts: Date.now(),
  };

  // Set cookie explicitly (attrs matter on modern browsers)
  Cookies.set(COOKIE_NAME, JSON.stringify(result), COOKIE_OPTS);
  // For debugging in PROD (browser console)
  // eslint-disable-next-line no-console
  console.log("[probe] set cookie", result);

  return result;
}
